/* eslint max-classes-per-file: "off" */

import {
  scrollToElement,
  scrollToPosition,
  calcScrollHeight,
} from '@js/src/shared-functions';

(() => {
  class ContentSwitchTrigger {
    /**
     * @param {HTMLButtonElement} $trigger
     * @param {ContentSwitch} contentSwitch
     */
    constructor($trigger, contentSwitch) {
      this.$trigger = $trigger;
      this.contentSwitch = contentSwitch;
      this.COMPONENT_CLASS = contentSwitch.COMPONENT_CLASS;
      this.contentSwitchHeader = this.contentSwitch.$contentSwitch.querySelector('.' + this.COMPONENT_CLASS + '__header');

      const targetId = $trigger.dataset.targetId || '';
      if (targetId === '') return;

      /** @type {HTMLElement|null} */
      const $target = document.getElementById(targetId);

      if (!($target instanceof HTMLElement)) return;

      this.$target = $target;

      this.$target.classList.add(this.COMPONENT_CLASS + '--hide-component');

      this.state = 'default';
      this.isOpen = true; // targets all visible on page load initially

      this.$trigger.addEventListener('click', () => this.toggle());
    }

    close() {
      this.isOpen = false;
      if (this.contentSwitch.hasActiveTriggers()) {
        this.setState('inactive');
      } else {
        this.contentSwitch.restoreDefaultStates();
        if (this.contentSwitch.isComponentLoaded) {
          scrollToElement(this.contentSwitch.$contentSwitch, 400);
        }
      }

      this.$trigger.ariaExpanded = false;

      // restore styling of component (remove style override)
      this.$target.style.marginBlockStart = null;
      this.$target.style.marginBlockEnd = null;
      this.$target.setAttribute('aria-hidden', 'true');
      this.$target.classList.remove(this.COMPONENT_CLASS + '--active-component');
      setTimeout(() => {
        this.$target.classList.remove(this.COMPONENT_CLASS + '--visible-component');
      }, 150);
    }

    open() {
      // order is important
      this.isOpen = true;
      this.setState('active');
      this.contentSwitch.closeAllTriggers(this);
      this.$trigger.ariaExpanded = true;

      // equalise spacing
      this.$target.style.marginBlockStart = '0';
      this.$target.style.marginBlockEnd = '96px';
      this.$target.removeAttribute('aria-hidden');
      this.$target.classList.add(this.COMPONENT_CLASS + '--visible-component');
      setTimeout(() => {
        this.$target.classList.add(this.COMPONENT_CLASS + '--active-component');
      }, 1);

      const scrollHeightHeaderBottom = calcScrollHeight(this.contentSwitchHeader).bottom;

      scrollToPosition(scrollHeightHeaderBottom, 400);
    }

    applyState() {
      switch (this.state) {
      case 'active':
        this.$trigger.classList.add(this.COMPONENT_CLASS + '__button--active');
        this.$trigger.classList.add('button--primary');
        this.$trigger.classList.remove('button--outlined');

        break;
      case 'inactive':
        this.$trigger.classList.remove(this.COMPONENT_CLASS + '__button--active');
        this.$trigger.classList.add('button--outlined');
        this.$trigger.classList.remove('button--primary');

        break;
      default:
        this.$trigger.classList.remove(this.COMPONENT_CLASS + '__button--active');
        this.$trigger.classList.add('button--primary');
        this.$trigger.classList.remove('button--outlined');
        break;
      }
    }

    /** @param {'default'|'active'|'inactive'} state */
    setState(state) {
      this.state = state;

      this.applyState();
    }

    toggle() {
      if (this.isOpen) { this.close(); } else { this.open(); }
    }
  }

  class ContentSwitch {
    /** @param {HTMLElement} $contentSwitch */
    constructor($contentSwitch) {
      if (!($contentSwitch instanceof HTMLElement)) return;

      this.COMPONENT_CLASS = 'content-switch';
      this.$contentSwitch = $contentSwitch;

      /** @type {ContentSwitchTrigger[]} */
      this.contentSwitchTriggers = [
        ...$contentSwitch.querySelectorAll('[data-selector="ContentSwitchTrigger"]'),
      ].map($trigger => new ContentSwitchTrigger($trigger, this))
        .filter(trigger => trigger instanceof ContentSwitchTrigger);

      this.$contentSwitchDescription = this.$contentSwitch.querySelector(
        '.' + this.COMPONENT_CLASS + '__content',
      );

      if (this.contentSwitchTriggers.length === 0) return;

      this.isComponentLoaded = false;
      this.closeAllTriggers();
      this.isComponentLoaded = true;
    }

    /** @param {?ContentSwitch} initiator */
    closeAllTriggers(initiator) {
      this.contentSwitchTriggers.forEach(trigger => {
        if (trigger !== initiator) {
          trigger.close();
        }
      });
    }

    restoreDefaultStates() {
      this.contentSwitchTriggers.forEach(trigger => {
        trigger.setState('default');
      });
    }

    /** @returns {boolean} */
    hasActiveTriggers() {
      return this.contentSwitchTriggers
        .filter(trigger => trigger.isOpen)
        .length !== 0;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const $contentSwitches = document.querySelectorAll('[data-module="ContentSwitch"]');

    $contentSwitches.forEach($contentSwitch => {
       
      new ContentSwitch($contentSwitch);
    });
  });
})();
